import { useEffect } from "react";
import Loader from "./common/loader";

function Login() {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.has("login_id")) {
      const login_id = urlParams.get("login_id");
      localStorage.setItem("login_id", login_id);
    }
    window.location.href = `https://developer.api.autodesk.com/authentication/v2/authorize?client_id=${process.env.REACT_APP_CLIENT_ID}&response_type=code&redirect_uri=${process.env.REACT_APP_REDIRECT_URL}&scope=data:read data:write data:create user-profile:read account:read`;
  }, []);

  return (
    <div style={{ position: "absolute", left: "50%", top: "50%" }}>
      <Loader />
    </div>
  );
}

export default Login;
